














































import Vue from 'vue';
import Component from 'vue-class-component';
import { State, Action } from 'vuex-class';
import { Prop } from 'vue-property-decorator';
import { getUserFullName, getDate } from '@/helpers/functions';
import EditorTest from '@/components/UI/EditorTest.vue';
import { client } from '@/store';
@Component({
  methods: {
    getUserFullName,
    getDate,
  },
  components: {
    EditorTest,
  },
})
export default class Chat extends Vue {
  @State('currentUser', { namespace: 'user' }) user: boolean;
  @Prop(Number)
  readonly chat: number;
  newMessage: string = '';
  currentChat = null;
  interval = null;
  async setChat(id?: number) {
    if (id !== null) {
      const { data } = await client.get(`chat/${id}`);
      this.currentChat = data;
      // @ts-ignore-next-line
      this.interval = setInterval(async () => {
        const { data } = await client.get(`chat/${id}`);
        this.currentChat = data;
      }, 5000);
      // @ts-ignore
    } else {
      // @ts-ignore-next-line
      clearInterval(this.interval);
      this.currentChat = null;
      this.interval = null;
    }
  }
  // @ts-ignore
  async sendMessage(content) {
    // @ts-ignore
    const { data } = await client.post('message', {
      // @ts-ignore
      chat_id: this.currentChat?.id,
      content,
      // @ts-ignore
      creator_id: this.user.id,
    });
    // @ts-ignore
    this.currentChat.messages.push(data);
  }
  mounted() {
    this.setChat(this.chat);
  }
  beforeDestroy() {
    // @ts-ignore
    this.setChat(null);
  }
  get messages() {
    // @ts-ignore
    return this.currentChat ? this.currentChat?.messages.slice().reverse() : [];
  }

  async send() {
    await this.sendMessage(this.newMessage);
    this.newMessage = '';
  }
}
